<template>
  <div>
    <button class="btn-start" type="button" @click="openModal">Start Now</button>
    <transition name="slide-fade">
      <popup v-if="showPopup" @close="showPopup = false"></popup>
    </transition>
  </div>
</template>

<script>
  import Popup from './Popup.vue'

  export default {
    name: 'StartNow',
    components: {
      'popup': Popup
    },
    data () {
      return {
        showPopup: false
      }
    },
    methods: {
      openModal () {
        this.showPopup = true
      }
    }
  }
</script>

<style scoped>
  .btn-start {
    font-family: 'RubicMedium', sans-serif;
    color: #fff;
    font-size: 18px;
    line-height: 21px;
    background: linear-gradient(90deg, #f03a03 0%, #ee28da 100%);
    border-radius: 50px;
    border: none;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/StartNow.vue